// TODO - needs to handle dynamic loading and clearing of the menu
namespace Nbs.Xlr8PageTemplate.Header.HeaderMenuButton {
  const menuButtonId = 'nbs-xlr8-page-template-header-menu-button';

  function ariaLabel(isCollapsed: boolean) {
    return isCollapsed ? 'open menu' : 'close menu';
  }

  function icon(isCollapsed: boolean) {
    return isCollapsed ? 'menu' : 'close';
  }

  function getElementForHeader() {
    const isCollapsed = Menu.MenuDom.isMenuCollapsed();
    return Utilities.createElement({
      tag: 'button',
      classes: ['xpt-header-menu-button'],
      attributes: {
        'aria-controls': 'xptNavMenu',
        'aria-expanded': !isCollapsed,
        'aria-haspopup': true,
        id: menuButtonId,
      },
      eventHandlers: {
        click: (event: MouseEvent) => {
          Menu.MenuDom.toggleMenu();
          updateIcon();
          Utilities.stopEvent(event);
          return false;
        }
      },
      children: [Utilities.getIconElement(icon(isCollapsed), ariaLabel(isCollapsed))]
    });
  }

  export function updateIcon() {
    const isCollapsed = Menu.MenuDom.isMenuCollapsed();

    const buttonElement = document.getElementById(menuButtonId);
    const iconElement = document.querySelector<HTMLElement>(`#${menuButtonId} i`);

    if (buttonElement) {
      buttonElement.setAttribute('aria-expanded', (!isCollapsed).toString());
    }

    if (iconElement) {
      iconElement.textContent = icon(isCollapsed);
      iconElement.setAttribute('aria-label', ariaLabel(isCollapsed));
    }
  }

  export function render() {
    const btn = document.getElementById(menuButtonId);
    if (!btn) {
      const header = Utilities.getFirstElementByClass('xpt-header-container');
      if (header) {
        header.insertBefore(getElementForHeader(), header.firstChild);
      }
    }
  }
}
